import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import WhyChoose from './components/WhyChoose';
import PackagesSection from './components/PackagesSection';
import AMCSection from './components/AMCSection';
import LuxurySection from './components/LuxurySection';
import BodyshopSection from './components/BodyshopSection';
import Compare from './components/Compare';
import FreePickup from './components/FreePickup';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import OfferPopup from './components/OfferPopup';
import StickyBook from './components/StickyBook';
import WhatsAppFloat from './components/WhatsAppFloat';
import AdminPage from './components/AdminPage';
import BookingReturn from './components/BookingReturn';
import PaymentPage from './components/PaymentPage';
import fbTrack from './lib/fbpixel';

function HomePage() {
  const [bookOpen, setBookOpen] = useState(false);
  const [initialPkg, setInitialPkg] = useState('diamond');

  const openBooking = (pkgId) => {
    if (pkgId) setInitialPkg(pkgId);
    setBookOpen(true);
    // Track InitiateCheckout when booking modal opens
    const priceMap = { diamond: 4999, basic: 3999, premium: 5999, luxury: 9999 };
    fbTrack.initiateCheckout(pkgId || 'diamond', priceMap[pkgId] || 4999);
  };

  return (
    <div className="App">
      <Navbar onBook={() => openBooking('diamond')} />
      <Hero onBook={() => openBooking('diamond')} />
      <Marquee />
      <WhyChoose />
      <PackagesSection onBook={openBooking} />
      <AMCSection onBook={openBooking} />
      <LuxurySection onBook={openBooking} />
      <Compare onBook={openBooking} />
      <FreePickup />
      <Testimonials />
      <CTASection onBook={openBooking} />
      <FAQ />
      <BodyshopSection />
      <Footer />
      <BookingModal open={bookOpen} onOpenChange={setBookOpen} initialPackage={initialPkg} />
      <OfferPopup onBook={openBooking} />
      <StickyBook onBook={openBooking} />
      <WhatsAppFloat />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<><AdminPage /><Toaster /></>} />
        <Route path="/booking/return" element={<><BookingReturn /><Toaster /></>} />
        <Route path="/pay" element={<><PaymentPage /><Toaster /></>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
